export const state = () => ({
  cookieBanner: null,
  globalLinks: null,
  newsletterSettings: null,
})

export const actions = {
  async loadNewsletterSettings({ state, commit }) {
    if (state.newsletterSettings) return state.newsletterSettings
    const { data } = await this.$axios.$get('globals/newsletter_settings')
    commit('setNewsletterSettings', data)
    return data
  },
  async loadCookieBanner({ commit }) {
    const { data } = await this.$axios.$get('globals/cookies')
    commit('setCookieBanner', data)
    return data
  },
  async loadGlobalLinks({ commit }) {
    const { data } = await this.$axios.$get('globals/links')
    commit('setGlobalLinks', data)
    return data
  },
}

export const mutations = {
  setNewsletterSettings(state, value) {
    state.newsletterSettings = value
  },
  setCookieBanner(state, value) {
    state.cookieBanner = value
  },
  setGlobalLinks(state, value) {
    state.globalLinks = value
  },
}
